{
    "coordinates": [
        39.40359901613482,
        -83.59843529165065
    ],
    "tooltip": "Cleveland Shale",
    "title": "Cleveland Shale",
    "country": "United States",
    "period": "Devonian",
    "alt": "TODO"
}
